
    <div class="subcapability">
        <h1 class="subcapability-title">{{name}}</h1>
        <p class="subcapability-text">{{content}}</p>
        <ng-content></ng-content>
    </div>
